import { Injectable, inject } from "@angular/core";

import { ApiHelper } from "../helpers/apihelper";
import { AuthService } from "./authservice";

@Injectable({ providedIn: "root" })
export class CustomerDescriptionService {
  private readonly api = inject(ApiHelper);
  private readonly auth = inject(AuthService);

  save(subscriptionId: string, description: string): Promise<unknown> {
    return this.api.set_customer_description(this.auth.viewingCustomer().customerId, subscriptionId, description);
  }
}
